// extracted by mini-css-extract-plugin
module.exports = {"fullScreen":"UnifiedLayout_fullScreen__SUHmP","headerText":"UnifiedLayout_headerText__2Va0n","logo":"UnifiedLayout_logo__FAn1l"};